/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingModulesEnum = 'SUBSCRIPTION_PROCESSOR' | 'EVENT_PROCESSOR' | 'USAGE_DOWNLOADER' | 'USAGE_PROCESSOR' | 'BILLING_PIPELINE' | 'SDDC_QUOTA';

export const BillingModulesEnum = {

    SUBSCRIPTION_PROCESSOR: 'SUBSCRIPTION_PROCESSOR' as BillingModulesEnum,

    EVENT_PROCESSOR: 'EVENT_PROCESSOR' as BillingModulesEnum,

    USAGE_DOWNLOADER: 'USAGE_DOWNLOADER' as BillingModulesEnum,

    USAGE_PROCESSOR: 'USAGE_PROCESSOR' as BillingModulesEnum,

    BILLING_PIPELINE: 'BILLING_PIPELINE' as BillingModulesEnum,

    SDDC_QUOTA: 'SDDC_QUOTA' as BillingModulesEnum
};

